var React = require('react');

function Signin (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"opacity":"0.4","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15,4.3","key":0}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t3.1,3.7 3.1,1.3 15,1.3 15,14.7 3.1,14.7 3.1,13.4 \t","key":1}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t11.6,8 7.5,6 7.5,8 7.5,10.1 \t","key":2}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.4","y1":"8","x2":"1","y2":"8","key":3})]));
}

Signin.displayName = "Signin";

Signin.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Signin;

Signin.default = Signin;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/signin.svg
// module id = ../icon/src/icons/signin.svg
// module chunks = 0